<template>
  <v-card
    color="grey lighten-4"
    light
  >
    <v-card-text>
      <content-section title="Quem sou eu?">
        Engenheiro da Computação com enfase em Engenharia de Software e também Tecnologo em Informática para Negócios. Experiência em Implantação, Configuração, Administração e Gestão de Ferramentas Atlassian (Jira, Confluence, BitBucket, Bamboo); Experiência em diversos plugins para Jira (EazyBI, RichFilter, ScriptRunner, Automation For Jira, entre outros); Desenvolvimento de Softwares (Delphi, PHP, VueJS, Groovy), gestão de equipe de desenvolvimento de sistemas, utilização de metodologias ágeis para desenvolvimento e prototipação de sistemas, elaboração de projetos e contratação de freelancers, modelagem e documentação de sistemas, elaboração de documentação técnica para fins regulatórios e de qualidade, administração e desenvolvimento de banco de dados, gestão de infraestrutura em ambiente cloud AWS, atendimento e fidelização de clientes, gestão de parcerias.
      </content-section>
      <content-section
        v-if="educations"
        title="Formação"
      >
        <v-layout
          v-for="(education, i) in educations"
          :key="i"
        >
          <v-flex md4>
            {{ education.from }} - {{ education.to }}
          </v-flex>
          <v-flex md8>
            <strong v-if="education.title">{{ education.title }}</strong>
            <div v-if="education.location">
              <i>{{ education.location }}</i>
            </div>
            <div v-if="education.description">
              {{ education.description }}
            </div>
            <v-flex
              md12
              xs12
              mb-4
            />
          </v-flex>
        </v-layout>
      </content-section>
      <content-section
        v-if="skills"
        id="to-timeline"
        title="Skills"
      >
        <template slot="actions">
          (% are relative not absolute)
        </template>
        <v-layout wrap>
          <template
            v-for="(skill, i) in skills"
          >
            <v-flex
              v-if="skill.divider"
              :key="i"
              md12
              xs12
              mb-4
            />
            <v-flex
              v-else
              :key="i"
              md6
              xs12
            >
              <div
                class="mr-2 ml-2"
              >
                <div class="align-center">
                  <v-icon
                    small
                  >
                    {{ skill.icon }}
                  </v-icon>
                  {{ skill.title }}
                </div>
                <v-progress-linear
                  class="progress"
                  color="secondary"
                  height="3"
                  :value="skill.value"
                />
              </div>
            </v-flex>
          </template>
        </v-layout>
      </content-section>
    </v-card-text>
  </v-card>
</template>

<script>
import ContentSection from '@/views/dark-template/content/Section'
export default {
  name      : 'MainContent',
  components: { ContentSection },
  data      : () => ({
    prouds: [
      {
        icon  : 'mdi-help-rhombus-outline',
        text  : 'Answered 10M+ questions!',
        source: '(Bytegate.ir post views)',
      },
      {
        icon  : 'mdi-library-music',
        text  : 'Made people enjoy and learn a new language for equivalent of 29+ years (older than myself!)',
        source: '(Bobet.ir and its channel downloads)',
      },
      {
        icon  : 'mdi-timer-sand',
        text  : 'Saved +110 days of time of students, writers and etc!',
        source: '(Delix.ir service usages)',
      },
      {
        icon  : 'mdi-account-multiple',
        text  : 'Tried to cover small part of 7 people expenses.',
        source: '(My awesome colleagues)',
      },
    ],
    educations: [
      {
        from       : '2017',
        to         : '2019',
        title      : 'Tecnologo em Informática para Negócios',
        location   : 'FATEC - Faculdade de Tecnologia de São Paulo',
        description: '',
      },
      {
        from       : '2012',
        to         : '2013',
        title      : 'Ciências da Comunicação, internet e Novas Mídias ',
        location   : 'UCP - Universidade Católica Portuguesa',
        description: 'Intercâmbio por 10 meses cursando matérias do curso em questão.',
      },
      {
        from       : '2009',
        to         : '2014',
        title      : 'Engenharia da Computação com Enfase em Engenharia de Software',
        location   : 'UMESP - Universidade Metodista de São Paulo',
        description: '',
      },
    ],
    skills: [
      {
        title: 'PHP',
        icon : 'mdi-language-php',
        value: 40,
      },
      {
        title: 'JavaScript',
        icon : 'mdi-language-javascript',
        value: 50,
      },
      {
        title: 'Borland Delphi',
        icon : 'mdi-developer-board',
        value: 90,
      },
      {
        title: 'Vue.js Framework',
        icon : 'mdi-vuejs',
        value: 70,
      },
      {
        title: 'Python',
        icon : 'mdi-language-python',
        value: 30,
      },
      {
        title: 'Groovy Scripts',
        icon : 'mdi-language-java',
        value: 40,
      },
      { divider: true },
      {
        title: 'Atlassian Ecosystem',
        icon : 'mdi-atlassian',
        value: 70,
      },
      {
        title: 'Database',
        icon : 'mdi-database',
        value: 60,
      },
      {
        title: 'Git',
        icon : 'mdi-git',
        value: 72,
      },
      {
        title: 'EazyBI',
        icon : 'mdi-chart-pie',
        value: 83,
      },
      {
        title: 'AWS',
        icon : 'mdi-aws',
        value: 46,
      },
      {
        title: 'AWS',
        icon : 'mdi-aws',
        value: 46,
      },
      { divider: true },
      {
        title: 'Metodologias Ágeis',
        icon : 'mdi-clock-fast',
        value: 78,
      },

      {
        title: 'ScriptRunner',
        icon : 'mdi-script-text',
        value: 58,
      },
      { divider: true },
    ],
  }),
}
</script>

<style scoped>
.title {
  border-bottom: 2px #bfbfbf solid;
  line-height: 1.5 !important;
}
.progress {
  margin-top: 0.1rem;
}
</style>
